<template>
  <div class="login-box">
    <div class="login-logo">
      <router-link to="/"><b>Admin</b> LTE</router-link>
    </div>
    <!-- /.login-logo -->
    <div class="login-box-body">
      <p class="login-box-msg">Connectez-vous</p>
      <form @submit.prevent="login">

        <div v-if="error" class="alert alert-danger">
          <a class="close" data-dismiss="alert">&times;</a>
          {{ error }}
        </div>

        <div class="form-group has-feedback">
          <input type="email" class="form-control" placeholder="Email" v-model="credentials.email">
          <span class="glyphicon glyphicon-user form-control-feedback"></span>
        </div>
        <div class="form-group has-feedback">
          <input type="password" class="form-control" placeholder="Mot de passe" v-model="credentials.password">
          <span class="glyphicon glyphicon-lock form-control-feedback"></span>
        </div>
        <div class="row">
          <div class="col-xs-8">
            <router-link :to="{name: 'register'}">S'inscrire</router-link>
            <p class="help-block"><a href="http://billetterie-paiement.ojssymphonique.net/password/forget">Mot de passe oublié ?</a></p>
          </div>
          <!-- /.col -->
          <div class="col-xs-4">
            <button type="submit" class="btn btn-primary btn-block btn-flat">Connexion</button>
          </div>
          <!-- /.col -->
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Login',
    data: function () {
      return {
        credentials: {
          email: '',
          password: ''
        },
        error: ''
      }
    },
    methods: {
      login: function () {
        var store = this.$store

        var credentials = {
          email: this.credentials.email,
          password: this.credentials.password
        }

        this.$http.post('http://ws.ojssymphonique.net/api/auth', credentials)
          .then(function (data) {
            var token = data.body.data.token
            store.commit('SET_TOKEN', token)

            // Save to local storage as well
            if (window.localStorage) {
              window.localStorage.setItem('token', token)
            }

            this.$router.push('/concerts')
          },
          function (data) {
            if (data.status === 422) {
              this.error = 'Il y a des erreurs sur le formulaire'
            } else {
              this.error = data.body.message
            }
          }
        )
      }
    },
    mounted: function () {
      require('icheck')

      $('input').iCheck({
        checkboxClass: 'icheckbox_square-blue',
        radioClass: 'iradio_square-blue',
        increaseArea: '20%' // optional
      })
    }
  }
</script>



// WEBPACK FOOTER //
// Login.vue?e77afa32